import { assocIf } from '@btime/helpers'
import { useLoggedUser, useSessionPermission } from '@btime/react-session'
import React from 'react'

import { useModalData } from '../../../components/modals/ModalsContext'
import { useParent } from './_load/ParentLoader'
import { useSaveServiceOrder } from './_requests/saveServiceOrder'
import { useServiceOrder } from './_load/ServiceOrderLoader'
import FieldsSection from './sections/FieldsSection'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import ModalFooter from './ModalFooter'
import ParentSection from './sections/ParentSection'

const EditServiceOrderForm = () => {
  const serviceOrder = useServiceOrder()
  const parent = useParent()
  const canSeeOnlySelfSOs = useSessionPermission('seeOnlySelfServiceOrders')
  const hasAddLeanServiceOrderPermission = useSessionPermission('createLeanServiceOrder')
  const loggedUser = useLoggedUser()

  const [onSubmit, { loading, error }] = useSaveServiceOrder()

  const { initialState, cloneFromId } = useModalData() || {}

  const data = {
    ...assocIf(!!parent?.address, 'address', parent?.address),
    ...assocIf(!!parent?.place?.id, 'place', parent?.place),
    ...assocIf(!!parent?.asset?.id, 'asset', parent?.asset),
    ...serviceOrder,
    ...initialState,
    ...assocIf(!!cloneFromId, 'id', undefined),
    ...assocIf(!!cloneFromId, 'status', undefined),
    ...assocIf(canSeeOnlySelfSOs, 'userOrGroup', loggedUser),
    ...assocIf(!!serviceOrder?.user, 'userOrGroup', serviceOrder?.user),
    ...assocIf(!!serviceOrder?.group, 'userOrGroup', serviceOrder?.group),
    ...assocIf(!!serviceOrder?.groups?.length, 'userOrGroup', serviceOrder?.groups),
    ...assocIf(!!serviceOrder?.place, 'place', serviceOrder?.place),
    ...assocIf(!!serviceOrder?.asset, 'asset', serviceOrder?.asset)
  }

  const isEditingExistingServiceOrder = !!data?.id

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={data}>
      <GeneralSection />
      {(!hasAddLeanServiceOrderPermission || isEditingExistingServiceOrder) && (
        <>
          <ParentSection />
          <FieldsSection />
        </>
      )}

      <ModalFooter loading={loading} error={error} onSubimit={onSubmit} />
    </Form>
  )
}

export default EditServiceOrderForm
